import {useCallback, useEffect, useRef, useState} from "react";

function savedPreference(key) {
    try {return localStorage.getItem(key) !== "false";} catch {return true;}
}

export default function useNotificationSound(preferenceKey, enabled) {
    const [soundEnabled, setSoundEnabled] = useState(() => savedPreference(preferenceKey));
    const preference = useRef(soundEnabled), audio = useRef(null);

    useEffect(() => {
        if (!enabled || typeof Audio === "undefined") return;
        const sound = new Audio("/notification.mp3");
        sound.preload = "none";
        audio.current = sound;
        return () => {sound.pause(); audio.current = null;};
    }, [enabled]);

    const playSound = useCallback(() => {
        if (!preference.current || !audio.current) return;
        try {
            audio.current.currentTime = 0;
            // Autoplay restrictions or an unavailable audio device must not interrupt the inbox.
            audio.current.play()?.catch(() => {});
        } catch { /* Notifications remain available when audio playback is unsupported. */ }
    }, []);

    const toggleSound = useCallback(() => {
        const next = !preference.current;
        preference.current = next;
        setSoundEnabled(next);
        try {localStorage.setItem(preferenceKey, String(next));} catch { /* Keep the session preference when storage is unavailable. */ }
        if (next) playSound();
        else audio.current?.pause();
    }, [preferenceKey, playSound]);

    return {soundEnabled, toggleSound, playSound};
}
